"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = void 0;
exports.filter = (fn) => async (args) => args.reduce((prev, arg) => prev.then(async (prevValue) => {
    const isIncluded = await fn(arg);
    if (isIncluded) {
        return [...prevValue, arg];
    }
    return prevValue;
}), Promise.resolve([]));
exports.default = exports.filter;
